import {
  ToggleButtonProps,
  iconButtonClasses as muiIconButtonClasses,
  IconButtonClasses as MuiIconButtonClasses,
} from '@mui/material';
import { IconButtonProps as MuiIconButtonProps, getIconButtonUtilityClass } from '@mui/material/IconButton';

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'onChange'> {
  /**
   * Aria label is required for accessibility reasons, it's what screen reader will read
   */
  ['aria-label']: string;
  /**
   * Color scheme for IconButton
   * @default text
   */
  variant?: 'text' | 'contained';
  /**
   * If true button has styles for selected variant
   */
  selected?: boolean;
  /**
   * If true circular spinner is shown inside
   */
  loading?: boolean;
  /**
   * Callback fired when the selected prop is defined and button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onChange?: ToggleButtonProps['onChange'];
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsSizeOverrides {
    extraSmall: true,
  }

  interface IconButtonClasses {
    sizeExtraSmall: string;
    selected: string;
    variantText: string;
    variantContained: string;
  }
}

export const iconButtonClasses: MuiIconButtonClasses = {
  ...muiIconButtonClasses,
  selected: getIconButtonUtilityClass('selected'),
  variantText: getIconButtonUtilityClass('variantText'),
  variantContained: getIconButtonUtilityClass('variantContained'),
  sizeExtraSmall: getIconButtonUtilityClass('sizeExtraSmall'),
};
